

import { request } from "@weapp/utils";
import { mainHost } from "../../utils";
import { publicUrlapi } from "../../constants";
import { encryptRsa } from "../../utils/encrypt";
const ETEAMSID = window.ETEAMSID;

//获取团队信息
export const getTeams = () => {
    return request({
        url: `/api/app/basicserver/siblingstenant/list`,
        method: "get",
    });
};
//查询团队信息
export const queryTenant = (params: any) => {
    return request({
        url: `/api/basicserver/addteam/queryTenant`,
        method: "get",
        params,
    });
};
//申请加入团队
export const applyTenant = (params: any) => {
    return request({
        url: `/api/basicserver/addteam/saveApply`,
        method: "get",
        params,
    });
};
//取消申请加入团队
export const cancleApply = (params: any) => {
    return request({
        url: `/api/basicserver/addteam/cancleApply`,
        method: "get",
        params,
    });
}
//创建团队
export const createTeams = (params: any) => {
    return request({
        url: `/api/basicserver/addteam/createTenant`,
        // url: `/api/basicserver/addteam/createTenantTemp`,
        method: "get",
        params,
        timeout: 0
    });
};
//团队列表切换时更改权限
export const changeTenantPermission = (params: any) => {
    const formData = new FormData();
    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            formData.append(key, params[key]);
        }
    }
    return request({
        url: `/api/basicserver/ipconfigrec/checkChangeTenantPermission`,
        method: "GET",
        params: {
            ...params
        }
    });
};
//团队列表切换更改LoginType
export const checkChangeTenantLoginType = (params: any) => {
    return request({
        url: `/api/basicserver/loginType/checkChangeTenantLoginType`,
        method: "get",
        params: {
            ETEAMSID,
            ...params
        }
    });
};

//app切换团队
export const changeTenant = (params: any) => {
    return request({
        url: (window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl) + `${publicUrlapi}/papi/passport/login/appChangeTenant`,
        method: "GET",
        params,
    });
};
//清除缓存
export const clearCookie = (cookies?: any) => {
    let url = `/papi/app/baseserver/clearCookie?service=${encodeURIComponent(window.location.href)}`;
    if (cookies) {
        if (cookies === 'ETEAMSID') {
            cookies = 'ETEAMSID,WECHAT_ETEAMSID'
        }
        url = `/papi/app/baseserver/clearCookieByName?cookieNames=${cookies}&service=${encodeURIComponent(window.location.href)}`
    }
    return request({
        url: url,
        method: "GET",
    });
};
//内部登录处理
export const login = (params: any) => {
    return request({
        url: mainHost() + "/papi/app/baseserver/login/teamsLogin",
        method: "POST",
        params: encryptRsa(params, "password"),
    });
};

export const adviceEeamsIdBind = (params: any) => {
    return request({
        url: mainHost() + `/api/app/basicserver/advice/adviceEteamsIdBind`,
        // url: "http://localhost:9088/api/app/basicserver/advice/bind",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        data: JSON.stringify({
            imei: params.imei,
            version: params.version,
            secondImei: params.secondImei,
            adviceInfo: params.adviceInfo,
            employeeId: params.employeeId
        })
    });
};
export const ssoCheck = (data: any) => {
    return request({
        url: `/papi/passport/checkTenant/ssoCheck`,
        method: "post",
        data: data
    });
}